// extracted by mini-css-extract-plugin
module.exports = {"header":"accountSimplifiedHeader_header__1iohH"};